import React, { useEffect } from 'react';
import 'simplebar-react/dist/simplebar.min.css';
//import Scss
import './assets/scss/themes.scss';
import "../src/assets/scss/common/common.scss";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
//imoprt Route
import Route from './Routes';
import { useNavigate } from 'react-router-dom';
import { useModuleTabClose } from 'hooks/useModuleTabClose';
import { setNavigate } from 'common/utils/navigation';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";


// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  const navigate = useNavigate();
  useModuleTabClose();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return (
    <React.Fragment>

      <Route />
    </React.Fragment>
  );
}

export default App;
